import { render, staticRenderFns } from "./testInformation.vue?vue&type=template&id=56eea392&scoped=true"
import script from "./testInformation.vue?vue&type=script&lang=js"
export * from "./testInformation.vue?vue&type=script&lang=js"
import style0 from "./testInformation.vue?vue&type=style&index=0&id=56eea392&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56eea392",
  null
  
)

export default component.exports